

enum WEEK_DAYS {
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY'
}

export default WEEK_DAYS;


// WEBPACK FOOTER //
// ./src/constants/weekDays.ts